module.exports = __webpack_public_path__ + "img/bang_perspective_matte.4de66987.png";